import React, { useCallback, useMemo, useState } from "react";
import ChipItem from "../ui/ChipItem";
import Flx from "../layout/Flx";
import { ReusableSelectableTable } from "./shared/ReusableSelectableTable";
import FilePreviewSideModal from "../modals/FilePreviewSideModal";
import { columnTypesDate } from "../../_src_shared/utils/agGrid/columnTypes/columnTypesDate";

const SelectableLoanFilesTable = ({
  files,
  selectedRows,
  setSelectedRows,
  height = "100%",
}) => {
  const TYPES = {
    list: "List",
    docGroup: "By Group",
    docType: "By Type",
  };

  const [file, setFile] = useState(null);

  const columnTypes = useMemo(() => {
    return {
      ...columnTypesDate(),
    };
  }, []);

  // Note: this returns a function that receives rowGroup
  // so ReusableSelectableTable can re-render columns when grouping changes.
  const columnDefs = useCallback(
    (rowGroup) => [
      {
        headerName: "Filename",
        field: "file_display_name",
        flex: 1,
        minWidth: 250,
        tooltipValueGetter: (params) => `Preview ${params.value}`,
        cellEditor: "agTextCellEditor",
        sort: rowGroup === TYPES.list ? "asc" : undefined,
        checkbox: true,
        cellStyle: {
          cursor: "pointer",
          fontSize: "11px !important",
          paddingLeft: 0,
        },
      },
      {
        headerName: "Document Group",
        field: "docGroup",
        rowGroup: rowGroup === TYPES.docGroup,
        hide: rowGroup === TYPES.list || rowGroup === TYPES.docGroup,
        width: 160,
        sort: rowGroup === TYPES.docGroup ? "asc" : undefined,
        valueGetter: (params) => {
          const value = params.data?.docGroup;
          return value === undefined || value === null || value === ""
            ? "Uncategorized"
            : value;
        },
        comparator: (valueA, valueB) => {
          if (valueA === "Uncategorized" && valueB !== "Uncategorized")
            return 1;
          if (valueA !== "Uncategorized" && valueB === "Uncategorized")
            return -1;
          return valueA.localeCompare(valueB);
        },
      },
      {
        headerName: "Document Type",
        field: "docType",
        rowGroup: rowGroup === TYPES.docType,
        hide: rowGroup === TYPES.docType,
        width: 160,
        sort: rowGroup === TYPES.docType ? "asc" : undefined,
        valueGetter: (params) => {
          const value = params.data?.docType;
          return value === undefined || value === null || value === ""
            ? "Uncategorized"
            : value;
        },
        comparator: (valueA, valueB) => {
          if (valueA === "Uncategorized" && valueB !== "Uncategorized")
            return 1;
          if (valueA !== "Uncategorized" && valueB === "Uncategorized")
            return -1;
          return valueA.localeCompare(valueB);
        },
        cellRenderer: (params) => {
          return (
            <Flx ac sx={{ height: "100%" }}>
              <ChipItem value={params?.value || "Uncategorized"} />
            </Flx>
          );
        },
      },
    ],
    [],
  );

  const handleCellClicked = useCallback((params) => {
    if (params?.node?.group) return;
    if (params?.colDef?.field === "file_display_name") {
      setFile(params.data);
    }
  }, []);

  return (
    <ReusableSelectableTable
      rowData={files}
      selectedRows={selectedRows}
      setSelectedRows={setSelectedRows}
      height={height}
      groupTypes={TYPES}
      columnTypes={columnTypes}
      getRowId={(params) => params.data._id}
      columnDefs={columnDefs}
      onCellClicked={handleCellClicked}
      renderBottom={() => (
        <FilePreviewSideModal file={file} onClose={() => setFile(null)} />
      )}
    />
  );
};
export default SelectableLoanFilesTable;
